import * as axios from 'axios';
import { useCookies } from "vue3-cookies";
const { cookies } = useCookies();
const BASE_URL = process.env.VUE_APP_ROOT_API;
let isRedirectingToLogin = false;

axios.interceptors.response.use(
  function (response) {
    if (Error(response)) {
      return Promise.reject({response: response, isSessionExpired: true});
    }
    return response;
  },
  function (error) {
    Error(error.response);
    return Promise.reject(error);
  }
);

function login(email, password, type) {
  return new Promise((resolve, reject) => {
    const url = `${BASE_URL}/authentication`;
    var data = JSON.stringify({
        "email": email,
        "password": password,
        "type": type
    });
    var config = {
      method: "post",
      url: url,
      timeout: 10000,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };
    axios(config).then(function (response) {
        resolve(response);
    }).catch(function (error) {
        resolve(error.response);
    });
  })
}

async function updateToken(token){
  let upd_token= token;
  const url = `${BASE_URL}/authentication`;
  let ref_token = cookies.get('refresh_token');
  var config2 = {
    method: "post",
    url: url,
    timeout: 10000,
    headers: {
      'Authorization': 'Bearer ' + token,
      'token': token,
      'refreshtoken': ref_token,
    },
  };
  var newToken = await axios(config2).then((response) => response).catch(function (error) {
    var isInvalidToken = Error(error.response);
    if(isInvalidToken == false){
      reject(error.response);
    }
  });
  upd_token = newToken.data.data.newToken.token;
  if (newToken.data.data.newToken.token) {
    cookies.keys().forEach(cookie=> cookie == 'token' ? cookies.remove(cookie, '/', process.env.VUE_APP_DOMAIN) : '');
    cookies.set('token', newToken.data.data.newToken.token, '1d', '/',
      process.env.VUE_APP_DOMAIN, 
      process.env.VUE_APP_PRODUCTION == 1, 
      process.env.VUE_APP_PRODUCTION == 1 ? 'None': 'Lax'
    )
  }
  if (newToken.data.data.newRefreshToken.token) {
    cookies.keys().forEach(cookie=> cookie == 'refresh_token' ? cookies.remove(cookie, '/', process.env.VUE_APP_DOMAIN) : '');
    cookies.set('refresh_token', newToken.data.data.newRefreshToken.token, '1d', '/',
      process.env.VUE_APP_DOMAIN, 
      process.env.VUE_APP_PRODUCTION == 1, 
      process.env.VUE_APP_PRODUCTION == 1 ? 'None': 'Lax'
    )
  }
  return upd_token;
}

function Error(response){
  if (!response) {
    return false;
  }

  const responseData = response.data || {};
  const errorMessages = [
    responseData.message,
    responseData.display_message,
    responseData.data,
    responseData.data?.message,
  ];
  const hasExplicitTokenError = errorMessages.some(message =>
    typeof message === 'string' && [
      'Invalid Token',
      'Invalid Ref Token',
      'Token kosong',
      'invalid_ref_token',
    ].includes(message)
  );
  const hasSystemError = errorMessages.some(message => message === 'error system');
  const authorization = response.config?.headers?.Authorization || response.config?.headers?.authorization;
  const hasAuthorization = typeof authorization === 'string' &&
    authorization !== 'Bearer null' &&
    authorization !== 'Bearer undefined' &&
    authorization !== 'Bearer ';
  const hasSession = cookies.isKey('token') || cookies.isKey('refresh_token') || hasAuthorization;
  const isInvalidSession = hasExplicitTokenError || (hasSystemError && hasAuthorization);

  if (isInvalidSession && hasSession) {
    if (!isRedirectingToLogin) {
      isRedirectingToLogin = true;
      cookies.keys().forEach(cookie=>cookies.remove(cookie, '/', process.env.VUE_APP_DOMAIN));
      window.location.replace('/login');
    }
    return true;
  }

  return false;
}
async function getFeed(path_url, token, body="") {
  return new Promise((resolve, reject) => {
    var config = {
      method: 'get',
      url: BASE_URL + path_url,
      timeout: 10000,
      headers: { 
        'Authorization': 'Bearer ' + token,
      }
    };
    if(body !== ""){
      config.data = body;
      config.headers = { 
                    'Content-Type': 'application/json', 
                    'Authorization': 'Bearer ' + token
                  };
    }
    axios(config).then(response => {
      resolve(response);
    }).catch(function (error) {
      var isInvalidToken = Error(error.response);
      if (isInvalidToken == false) {
        reject(error.response);
      }
    });
  })
}
async function PostFeed(path_url, token, data, method) {
    return new Promise((resolve, reject) => {
      var config = {
        method: method,
        url: BASE_URL + path_url,
        timeout: 10000,
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        },
        data: data,
      };
  axios(config).then(function (response) {
    resolve(response);
  }).catch(function (error) {
    var isInvalidToken = Error(error.response);
    if (isInvalidToken == false) {
      reject(error.response);
    }
  });
})
}
async function getDelete(path_url, token, data) {
  //token = await updateToken(token);
  return new Promise((resolve, reject) => {
    var config = {
      method: "delete",
      url: BASE_URL + path_url,
      timeout: 10000,
      headers: {
        Authorization: "Bearer " + token,
      },
      data: data,
    };
    axios(config).then(function (response) {
      resolve(response);
    }).catch(function (error) {
      var isInvalidToken = Error(error.response);
      if (isInvalidToken == false) {
        reject(error.response);
      }
    });
  })
}
async function PostLog(path_url, token, data, method) {
  return new Promise((resolve, reject) => {
    var config = {
      method: method,
      url: BASE_URL + path_url,
      timeout: 10000,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
      data: data,
    };
    axios(config).then(function (response) {
      resolve(response);
    }).catch(function (error) {
      var isInvalidToken = Error(error.response);
      if (isInvalidToken == false) {
        reject(error.response);
      }
    });
  })
}
async function getPatch(path_url, token, body="") {
  return new Promise((resolve, reject) => {
    var config = {
      method: 'PATCH',
      url: BASE_URL + path_url,
      timeout: 10000,
      headers: { 
        'Authorization': 'Bearer ' + token,
      },
      data: body
    };
    axios(config).then(response => {
      resolve(response);
    }).catch(function (error) {
      var isInvalidToken = Error(error.response);
      if (isInvalidToken == false) {
        reject(error.response);
      }
    });
  })
}
export { login, getFeed, PostFeed, getDelete, PostLog, getPatch}
